<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd()" icon="el-icon-edit">新建</el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="getLoad()"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <div class="tree-box fillh" style="overflow-y: auto">
                    <div v-if="cats.length > 0">
                        <div v-for="item in cats" :key="item.cat_id">
                            <div class="flex-box pd-5">
                                <Icon class="f-back mg-right5" type="logo-buffer" />{{item.cat_cname}}
                            </div>
                            <div class="sub-tree pd-5 c1" v-for="item2 in item.children" :key="item2.cat_id2">
                                <div class="flex-box pd-5">
                                    <Icon class="f-back mg-right5" type="logo-buffer" />{{item2.cat_cname}}
                                </div>
                                <div class="sub-tree c2 border-bottom-line" v-for="item3 in item2.goods" :key="item3.goods_id">
                                    <div class="flex-box nopadding">
                                        <div class="width-60">
                                            <myImgshow :src="item3.img_lnk" @onClick="$base.alertImg(item3.img_lnk, item3.goods_cname)"></myImgshow>
                                        </div>
                                        <div class="mg-left10 flex-box-bd tleft">
                                            <el-tag size="mini" :class="item3.goods_status == '1'?'bg-green':'bg-gray'">
                                                {{item3.goods_status_cdesc}}
                                            </el-tag>
                                            <div class="mg-top5 f-bd">{{item3.goods_cname}}</div>
                                        </div>
                                        <a class="link" @click="openSave(item3.goods_id)">详情</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <myNodata></myNodata>
                    </div>
                </div>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myDatePicker from "../../../components/myDatePicker"
    import myImgshow from '../../../components/myImgshow'
    import myNodata from '../../../components/myNodata'
    export default {
        name:'product-code',
        components:{
            myDatePicker,
            myImgshow,
            myNodata
        },
        data:function(){
            return{
                self:this,
                show_subview:false,
                relist:false,
                cats:[]
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.getLoad();
        },
        methods:{
            getLoad: function () {
                this.$base.showLoading();
                this.$request.sendPost("product-code/before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openAdd:function () {
                this.$base.linkTo("/product/code/save",{op:'add'});
            },
            openSave:function (id) {
                this.$base.linkTo("/product/code/save",{op:'upd', id});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.getLoad();
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/code/list.vue